export default __webpack_public_path__ + "static/media/Plant State Serums.081b9e8f.png";